import { css } from "@emotion/react";
import styled from "@emotion/styled";
import React, { ReactNode } from "react";
import Link from "src/components/buttons/LinkButton";
import colors from "src/utils/colors";

interface ItemTitleProps {
  isDetail?: boolean;
  className?: string;
  type?: string;
  to?: string;
  color?: string;
  children: ReactNode;
}

class ItemTitleComponent extends React.Component<ItemTitleProps, {}> {
  render() {
    if (this.props.to) {
      return (
        <Link className={this.props.className} to={this.props.to}>
          {this.props.children}
        </Link>
      );
    }
    return <h2 className={this.props.className}>{this.props.children}</h2>;
  }
}

export default styled(ItemTitleComponent)`
  font-weight: bold;
  color: ${(props) => (props.color ? props.color : colors.dark)};
  display: block;
  margin: 0;
  font-size: 1rem;
  ${(props: ItemTitleProps) =>
    props.type === "schedule" &&
    css`
      font-size: 1.5rem;
      margin-bottom: 0;
    `};
  ${(props: ItemTitleProps) =>
    props.isDetail &&
    css`
      font-size: 1.6rem;
      margin-bottom: 0.5rem;
    `};
`;
